export const formatTimeMSs = (seconds) => new Date(seconds * 1000).toISOString().substring(14, 21)
